<template>
    <div class="phone-number" @mouseleave="dropdown = false">
        <div class="supsis-dropdown">
            <div
                :key="'dropdown-phone-c'"
                class="supsis-dropdown-selected"
                @click="dropdown = !dropdown"
                v-if="country"
            >
                <span class="flag">{{ country.emoji }}</span>
                <span class="code">{{ country.dial_code }}</span>
            </div>
        </div>
        <div class="supsis-dropdown-menu" :class="dropdown && 'opened'" @mouseup="dropdown = true">
            <div
                v-if="dropdown"
                class="supsis-dropdown-item"
                v-for="c of countryPhoneInfos"
                :key="c.code"
                @click="onClick(c.code)"
            >
                {{ c.emoji }} ({{ c.dial_code }}) {{ c.name }}
            </div>
        </div>
        <md-input
            :autofocus="autofocus"
            :name="name"
            :v-validate="vValidate"
            class="phone-input"
            type="number"
            v-model="phoneNumber"
            :key="location.dial_code"
            @change="changePhoneNumber"
        />
    </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
    components: {},
    props: {
        vValidate: {
            type: String,
            default: null,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            phoneNumber: null,
            country: null,
            dropdown: false,
        };
    },
    methods: {
        onClick(code) {
            this.country = this.countryPhoneInfos.find((x) => x.code == code);
            this.dropdown = false;
            this.$emit("input", this.phoneNumber && this.country.dial_code + this.phoneNumber);
        },
        changePhoneNumber() {
            this.$emit("input", this.phoneNumber && (this.country || this.location).dial_code + this.phoneNumber);
        },
        getCountries() {
            return this.countryPhoneInfos.filter(Boolean).map((country) => ({
                value: country.code,
                label: `${country.emoji} ${country.name}`,
            }));
        },
        retrieveFromLocalStorage() {
            const storedPhoneNumber = localStorage.getItem("phoneNumber");
            if (storedPhoneNumber) {
                this.phoneNumber = storedPhoneNumber;
            }
        },
    },
    computed: {
        ...mapState({
            location: (state) => state.app.location,
            countryPhoneInfos: (state) => state.app.countryPhoneInfos.filter((x) => !!x),
        }),
    },
    mounted() {
        this.country = this.location;

        this.retrieveFromLocalStorage();
    },
    watch: {
        location: {
            handler() {
                this.country = this.location;
            },
            deep: true,
        },
        phoneNumber: {
            handler(newPhoneNumber) {
                localStorage.setItem("phoneNumber", newPhoneNumber);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.v2 {
    .phone-number {
        width: 100%;
        display: flex;
        justify-content: start;
        align-items: center;

        .supsis-dropdown {
            position: relative;
        }

        .supsis-dropdown-menu {
            border-radius: 5px;
            width: 100%;
            position: absolute;
            top: 30px;
            left: 0;
            background-color: #fff;
            height: 0px;
            opacity: 0;
            overflow-y: scroll;
            overflow-x: hidden;
            z-index: 999;
            padding: 5px 10px;
            transition: all 0.2s;

            &.opened {
                opacity: 1;
                height: 170px !important;
            }

            .supsis-dropdown-item {
                padding: 3px 7px;
                overflow: hidden;
                user-select: none;
                color: #000 !important;
                font-size: 12px;

                &:hover {
                    background-color: rgb(222, 222, 222);
                }
            }
        }

        .supsis-dropdown-selected {
            user-select: none;
            cursor: pointer;
            height: 32px !important;
            display: flex !important;
            align-items: center !important;
            text-decoration: none !important;
            color: #fff !important;
            background: transparent !important;

            .flag {
                font-size: 18px;
                margin-right: 5px;
                color: var(--form-input-label) !important;
            }

            .code {
                font-weight: 400;
                flex: 2;
                color: var(--form-input-label) !important;
            }
        }

        .phone-input::-webkit-outer-spin-button,
        .phone-input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input.phone-input {
            color: var(--form-input-label) !important;
            background: transparent !important;
            outline: none !important;
            border: none !important;
            box-shadow: none !important;
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/SelectPhoneInput.vue